import { Autocomplete } from "@/components/Selector/Autocomplete"
import { LANGUAGES } from "@/constants/LangConstants"
import { useCallback } from "react"
import { FormattedMessage, useIntl } from "react-intl"

const langOptions = LANGUAGES.map(({ code: value, label }) => ({
  label,
  value,
}))

export const SidebarAccountLang = () => {
  const intl = useIntl()
  const { locale } = intl

  const onLangChange = useCallback(
    (value: string) => {
      const { pathname, search } = window.location
      window.location.href = (pathname + search).replace(`/${locale.toLowerCase().substring(0, 2)}`, `/${value.toLowerCase().substring(0, 2)}`)
    },
    [locale],
  )

  return (
    <div className="pb-4 " onClick={(e) => e.stopPropagation()}>
      <FormattedMessage id="language" />
      <Autocomplete
        options={langOptions}
        value={{
          value: locale,
          label: langOptions.find((lang) => lang.value === locale)?.label ?? "",
        }}
        //@ts-ignore
        onChange={({ value }) => onLangChange(value)}
      />
    </div>
  )
}
